export default __webpack_public_path__ + "static/media/vol7_3.cc28c3ff.png";